import { render, staticRenderFns } from "./MiniBlock.vue?vue&type=template&id=c4060c28&"
import script from "./MiniBlock.vue?vue&type=script&lang=js&"
export * from "./MiniBlock.vue?vue&type=script&lang=js&"
import style0 from "./MiniBlock.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports